export function getConstAsSelectOptions(data): Array<{ value: string; label: string }> {
  return Object.entries(data).map(([key, value]) => ({
    value: key,
    label: value as string,
  }));
}
